import { createFileRoute } from '@tanstack/react-router';

import { PatentSearchClaimable } from '@/module/Author/Patent/PatentSearchClaimable';

export const Route = createFileRoute('/_auth/author/_author/patent/_patent/search-claimable')({
  component: PatentSearchClaimable,
  staticData: {
    pageTitle: { id: 'pageTitle.create' },
  },
});
